import { render } from "./SMSLoginModal.vue?vue&type=template&id=c4b3b0ea&scoped=true&ts=true"
import script from "./SMSLoginModal.vue?vue&type=script&lang=ts"
export * from "./SMSLoginModal.vue?vue&type=script&lang=ts"

import "./SMSLoginModal.vue?vue&type=style&index=0&id=c4b3b0ea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/flowerdiy/flowerdiy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4b3b0ea"]])

export default __exports__